module.exports = __webpack_public_path__ + "../resources/img/ic_re_thumbsup_default.8bb2c148.svg";